import { GridValueEditorService } from "../common/gridValueEditor/service/gridValueEditorService";

class SkusChartAndTableComponentController {
    public brand: $TSFixMe;
    public parameters: $TSFixMe;
    public showInMilions: boolean = false;
    public showChart: boolean = true;
    public labels: $TSFixMe;
    public emptyHistoricalArray: $TSFixMe[];
    public skusGridOptions: $TSFixMe;
    public options: $TSFixMe;
    public datasetOverride: $TSFixMe;
    public itemsToDisplay: $TSFixMe;
    public chartInstance: $TSFixMe;

    static $inject = [
        '$scope',
        'dtpChartService',
        '$timeout',
        GridValueEditorService.componentName,
        'FileSaver'
    ];

    constructor(
        private $scope: ng.IScope,
        private dtpChartService: $TSFixMe,
        private $timeout: ng.ITimeoutService,
        private gridValueEditorService: GridValueEditorService,
        private FileSaver: $TSFixMe
    ) {
        this.showInMilions = false;
        this.showChart = true;
    }

    $onInit() {
        this.labels = this.dtpChartService.preparePeriodsAndLabels(this.parameters.historicalDataStart, this.parameters.forecastEndDate).periods;
        const historicalDataLength = this.dtpChartService.getPeriodLenghtInMonths(this.parameters.historicalDataStart, this.parameters.historicalDataEnd);
        this.emptyHistoricalArray = _.times(historicalDataLength, _.constant(null));

        this.$scope.$watch('$ctrl.brand', () => this.refreshDebounce(), true);
        this.$scope.$watchGroup(['$ctrl.skusVal'], () => this.refreshData());

        this.skusGridOptions = {
            gridName: 'skuSummary',
            header: this.gridValueEditorService.prepareHeaderData(this.parameters.historicalDataStart, this.parameters.forecastEndDate),
            readOnly: true
        };
        this.options = {
            scales: {
                yAxes: [
                    {
                        ticks: {
                            suggestedMin: 0
                        }
                    }
                ]
            }
        };

        this.$scope.$on('chart-create', (e: $TSFixMe, chartInstance: $TSFixMe) => {
            this.chartInstance = chartInstance;
        });
    }

    private refreshDebounce() {
        if (angular.isDefined((this.$scope as $TSFixMe).watchTimeout)) {
            this.$timeout.cancel((this.$scope as $TSFixMe).watchTimeout);
        }
        (this.$scope as $TSFixMe).watchTimeout = this.$timeout(() => this.refreshData(), 500);
    }

    public exportChart = () => {
        const canvas = this.chartInstance.chart.canvas;
        canvas.toBlob((blob: $TSFixMe) => {
            this.FileSaver.saveAs(blob, 'wykres.png');
        }, 'image/png', 1);
    };

    private refreshData() {
        const gridData = this.getSkusForecastData();
        this.skusGridOptions.gridData = gridData;
        this.refreshChart(gridData);
    }

    private refreshChart(gridData: $TSFixMe) {
        this.datasetOverride = gridData.map((data: $TSFixMe) => ({
            label: data.header
        }));
        this.itemsToDisplay = gridData.map((data: $TSFixMe) => data.values);
    }

    private getSkusForecastData() {
        const gridData = [];
        if (this.brand) {
            for (const sku of this.brand.skus) {
                gridData.push({
                    header: `${sku.name} - ${sku.oracleIndex}`,
                    values: this.getSkuForecastArray(sku)
                });
            }
        }
        return gridData;
    }

    private getSkuForecastArray(sku: $TSFixMe) {
        if (this.parameters.forecastMethod.methodId === 'sku') {
            if ((this as $TSFixMe).skusVal) {
                return this.getNullHistoricalArrayIfEmpty(sku.forecast.historicalValueData).concat(sku.forecast.value.pmForecast);
            } else {
                return this.getNullHistoricalArrayIfEmpty(sku.forecast.historicalData).concat(sku.forecast.pmForecast);
            }
        } else {
            if ((this as $TSFixMe).skusVal) {
                return this.getNullHistoricalArrayIfEmpty(sku.forecast.historicalValueData).concat(sku.forecast.value.pmForecast);
            } else {
                if (this.parameters.forecastType.typeId === 'dot') {
                    return this.getNullHistoricalArrayIfEmpty(sku.forecast.historicalDotData).concat(sku.forecast.dot.pmForecast);
                } else {
                    return this.getNullHistoricalArrayIfEmpty(sku.forecast.historicalVolumeData).concat(sku.forecast.volume.pmForecast);
                }
            }
        }
    }

    private getNullHistoricalArrayIfEmpty(array: $TSFixMe) {
        return (!array || array.length == 0) ? this.emptyHistoricalArray : array;
    }
}

export class SkusChartAndTableComponent implements ng.IComponentOptions {
    static componentName = 'skusChartAndTable';
    bindings = {
        brand: '<',
        parameters: '<'
    };
    controller = SkusChartAndTableComponentController;
    template = require('./skusChartAndTableComponent.html');
}

angular.module('topline.modules').component(SkusChartAndTableComponent.componentName, new SkusChartAndTableComponent());